import "@dxos/node-std/globals"

// packages/common/timeframe/src/timeframe.ts
import { inspect } from "@dxos/node-std/util";
import { equalsSymbol } from "@dxos/debug";
import { PublicKey } from "@dxos/keys";
import { ComplexMap } from "@dxos/util";
var Timeframe = class {
  constructor(frames = []) {
    this._frames = new ComplexMap(PublicKey.hash);
    for (const [key, seq] of frames) {
      this.set(key, seq);
    }
  }
  toJSON() {
    return this.frames().reduce((frames, [key, seq]) => {
      frames[key.truncate()] = seq;
      return frames;
    }, {});
  }
  toString() {
    return `(${this.frames().map(([key, seq]) => `${key.truncate()}[${seq}]`).join(", ")})`;
  }
  // TODO(burdon): Rename getFrame.
  get(key) {
    return this._frames.get(key);
  }
  // TODO(burdon): Rename setFrame.
  set(key, value) {
    this._frames.set(key, value);
  }
  // TODO(burdon): Change to getter.
  frames() {
    return Array.from(this._frames.entries()).filter((frame) => !!frame);
  }
  // TODO(burdon): Change to getter.
  size() {
    return this._frames.size;
  }
  // TODO(burdon): Change to getter (empty).
  isEmpty() {
    return this.size() === 0;
  }
  /**
  * Returns a new timeframe with specified keys removed.
  * @param keys
  */
  withoutKeys(keys) {
    return new Timeframe(this.frames().filter(([frameKey]) => keys.every((key) => Buffer.compare(key.asBuffer(), frameKey.asBuffer()) !== 0)));
  }
  map(fn) {
    return new Timeframe(this.frames().map(fn));
  }
  /**
  * Returns a total amount of messages represented by this timeframe.
  */
  totalMessages() {
    return Array.from(this._frames.values()).reduce((result, seq) => result + seq + 1, 0);
  }
  /**
  * Used by NodeJS to get textual representation of this object in `console.log`.
  */
  [inspect.custom]() {
    return `Timeframe${this.toString()}`;
  }
  equals(other) {
    return this.size() === other.size() && this.frames().every(([key, seq]) => other.get(key) === seq);
  }
  [equalsSymbol](other) {
    if (!(other instanceof Timeframe)) {
      return false;
    }
    return this.equals(other);
  }
  /**
  * Merges the values, updating the highest sequence numbers.
  * @param timeframes
  */
  static merge(...timeframes) {
    const result = new Timeframe();
    for (const timeframe of timeframes) {
      for (const [key, seq] of timeframe.frames()) {
        const current = result.get(key);
        if (current === void 0 || seq > current) {
          result.set(key, seq);
        }
      }
    }
    return result;
  }
  /**
  * Compares two timeframes and returns an array of frames from the first timeframe where the sequence number
  * is greater than the associated sequence number from the second timeframe.
  */
  static dependencies(tf1, tf2) {
    const result = new Timeframe();
    for (const [key, seq] of tf1.frames()) {
      const otherSeq = tf2.get(key);
      if (otherSeq === void 0 || otherSeq < seq) {
        result.set(key, seq);
      }
    }
    return result;
  }
};
export {
  Timeframe
};
//# sourceMappingURL=index.mjs.map
